import { HeartHandshake } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { scrollToId } from "@/components/Header";

const CUTX_LOGO = "/sponsor-cutx.png";
const ALLEN_PD_LOGO = "/sponsor-allenpd.png";

const SPONSORS = [
  {
    logo: CUTX_LOGO,
    name: "Credit Union of Texas",
    sub: "Charitable Foundation",
    testid: "sponsor-cutx",
    imgClass: "h-14 md:h-16",
  },
  {
    logo: ALLEN_PD_LOGO,
    name: "Allen Police Department",
    sub: "Community Partner",
    testid: "sponsor-allen-pd",
    imgClass: "h-20 md:h-24",
  },
];

export const Sponsors = () => (
  <section data-testid="sponsors-section" className="border-y border-black/5 bg-[#062012] py-20 text-white md:py-24">
    <div className="mx-auto max-w-7xl px-4 md:px-8">
      <Reveal>
        <p
          data-testid="sponsors-overline"
          className="mb-12 text-center text-sm font-semibold uppercase tracking-[0.3em] text-hope-bright"
        >
          Presented with Gratitude To Our Partners
        </p>
      </Reveal>
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="sponsors-grid">
        {SPONSORS.map((s, i) => (
          <Reveal key={s.name} delay={i * 0.1}>
            <div
              data-testid={s.testid}
              className="flex h-full flex-col items-center justify-center rounded-3xl border border-white/10 bg-white/5 px-8 py-10 text-center transition-all duration-300 hover:-translate-y-1 hover:border-hope-green/50"
            >
              <img
                src={s.logo}
                alt={`${s.name} ${s.sub} logo`}
                data-testid={`${s.testid}-logo`}
                className={`${s.imgClass} w-auto object-contain`}
              />
              <p className="mt-5 font-heading text-lg font-bold text-white">{s.name}</p>
              <p className="mt-1 text-xs uppercase tracking-[0.2em] text-white/50">{s.sub}</p>
            </div>
          </Reveal>
        ))}
        <Reveal delay={0.2}>
          <a
            href="#contact"
            onClick={scrollToId("#contact")}
            data-testid="sponsor-cta-card"
            className="group flex h-full flex-col items-center justify-center rounded-3xl border-2 border-dashed border-hope-green/40 px-8 py-10 text-center transition-all duration-300 hover:-translate-y-1 hover:border-hope-green hover:bg-hope-green/10"
          >
            <span className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-hope-red/15 text-hope-red">
              <HeartHandshake className="h-7 w-7" />
            </span>
            <p className="font-heading text-lg font-bold text-white">Become a Sponsor</p>
            <p className="mt-1 text-xs uppercase tracking-[0.2em] text-white/50 group-hover:text-hope-bright">
              Put your brand behind hope
            </p>
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);
